import { create } from "zustand";
import { CourseTema } from "../const/types";

type State = {
  tema: CourseTema | null;
};

type Action = {
  setTema: (newTema: State["tema"]) => void;
};

const useTemaAllCourses = create<State & Action>((set) => ({
  tema: null,
  setTema: (newTema) => set(() => ({ tema: newTema })),
}));

export default useTemaAllCourses;
